import { HttpInterceptorFn } from '@angular/common/http';
import { getAuthToken } from '../utility/login-info';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { PapiAuthService } from '../services/papi-auth.service';
import { catchError, throwError } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseModalComponent } from '../../components/shared/response-modal/response-modal.component';
const LOGIN_ENDPOINT = 'v1/authenticate/login';
let isTokenModalOpen = false;
export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const token = getAuthToken();
  const router = inject(Router);
  const authService = inject(PapiAuthService);
  const modalService = inject(NgbModal);

  if (req.url.includes(LOGIN_ENDPOINT)) {
    return next(req);
  }
  let authReq = req;
  if (token) {
    authReq = req.clone({
      setHeaders: {
        Authorization: `${token}`,
      },
    });
  }
  return next(authReq).pipe(
    catchError((error) => {
      if ((error.status === 401) && !isTokenModalOpen) {
        isTokenModalOpen = true;
        const modalRef = modalService.open(ResponseModalComponent, {
          backdrop: false,
          keyboard: false,
          centered: true,
          size: 'sm',
        });
        const component = modalRef.componentInstance as ResponseModalComponent;
        component.message = 'Your session has expired. Please log in again to continue.';
        const resetAndLogout = () => {
          isTokenModalOpen = false;
          authService.clearCredentials();
          router.navigate(['/login']);
        };
        modalRef.result.then(resetAndLogout, resetAndLogout);
      }
      return throwError(() => error);
    })
  );
};